import { render } from "./AppCropper.vue?vue&type=template&id=60b07118&scoped=true&ts=true"
import script from "./AppCropper.vue?vue&type=script&lang=ts"
export * from "./AppCropper.vue?vue&type=script&lang=ts"

import "./AppCropper.vue?vue&type=style&index=0&id=60b07118&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b07118"]])

export default __exports__